import { jsx as _jsx } from "react/jsx-runtime";
import { createSvgIcon } from '@material-ui/core'

export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zM8 11h2v3h4v-3h2l-4-4-4 4z"
}), 'OutboxIcon');